// App
import { App } from "@js/app";

// Styles
import "@styles/style.scss";

const app = new App();
app.init();
